import { MediaQuery as o } from "../../styles/variables.js";
import { styled as i } from "styled-components";
const e = "50% 50%", t = "150%", n = "zoom-in", c = i.figure`
  background-position: ${e};
  background-size: ${t};
  background-repeat: no-repeat;
  cursor: ${n};
  position: relative;
  display: inline-flex;
  overflow: hidden;
  -webkit-touch-callout: none;
  user-select: none;
  width: max-content;

  &:not([aria-invalid='true']) img:hover {
    opacity: 0;
  }

  &[aria-invalid='true'] {
    cursor: default;
  }

  img {
    transition: opacity 0.5s;
    display: block;
    width: 100%;
    height: auto;
    background: #fff;
  }

  @media ${o.SCREEN_SM} {
    pointer-events: none;
  }
`;
export {
  n as DEFAULT_CURSOR,
  e as DEFAULT_POSITION,
  t as DEFAULT_SIZE,
  c as FigureContainer
};
